import { popupError, getZendeskUrl } from "@service/zendesk";
import { useNavigate } from "react-router-dom";

export const useSuccess = () => {
  const navigate = useNavigate();

  const openTicketWindow = (ticketId: string) => {
    if (!ticketId || ticketId === "") {
      popupError("Erro ao abrir ticket.", false);
      return;
    }

    window.open(getZendeskUrl() + "/agent/tickets/" + ticketId);
  };

  const backPage = () => {
    navigate("/");
  };

  return {
    openTicketWindow,
    backPage,
  };
};
